export const getComponentsDefault = () => ({
	kinds: [],
	collections: [],
	colors: [],
	sizes: [],
	tags: [],
	pricePolicies: []
});
